import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import { LayoutComponent } from '@shared/component';
import { PersonaService, PageTitleService } from '@shared/service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, LayoutComponent],
  templateUrl: './app.component.html',
  
})
export class AppComponent implements OnInit {
  private readonly persona = inject(PersonaService);
  private readonly router = inject(Router);
  private readonly pageTitleSvc = inject(PageTitleService);

  ngOnInit(): void {
    this.persona.bootstrapFromDevQueryParam();

    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => this.updatePageTitle());

    this.updatePageTitle();
  }

  private updatePageTitle(): void {
    let route = this.router.routerState.root;
    while (route.firstChild) route = route.firstChild;
    const dataTitle = route.snapshot.data['title'] as string | undefined;
    const url = this.router.url.split('?')[0];
    const seg = url.split('/').filter(Boolean).pop() || 'dashboard';
    this.pageTitleSvc.setTitle(dataTitle ?? this.titleize(seg));
  }

  private titleize(slug: string): string {
    return slug.replace(/[-_]/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }
}
